export default function FlowBuilder({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative w-full h-[150px] overflow-x-auto">{children}</div>
  );
}

type FlowBuilderTrackProps = {
  children: React.ReactNode;
  lineStart?: number; // px
  lineEnd?: number; // px
};

FlowBuilder.Track = function FlowBuilderTrack({
  children,
  lineStart = 40,
  lineEnd = 0,
}: FlowBuilderTrackProps) {
  return (
    <div className="relative inline-flex justify-start items-start gap-8 text-xs">
      {children}

      {/* Horizontal lines  */}
      <div
        className="absolute top-4 h-[1.2px] bg-gray-300"
        style={{
          left: lineStart,
          right: lineEnd,
        }}
      />
    </div>
  );
};

FlowBuilder.Item = function FlowBuilderItem({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className="flex gap-8">{children}</div>;
};

type FlowBuilderStepProps = {
  children: React.ReactNode;
  draggable?: boolean;
  onDragStart?: () => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: () => void;
};

FlowBuilder.Step = function FlowBuilderStep(props: FlowBuilderStepProps) {
  const { children, draggable, onDragStart, onDragOver, onDrop } = props;

  return (
    <div
      className="relative z-10 w-[80px] text-center text-gray-900 flex flex-col items-center justify-start gap-2"
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {children}
    </div>
  );
};

FlowBuilder.Badge = function FlowBuilderBadge({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <h4 className="size-8 text-lg bg-white z-10 flex items-center justify-center p-1 border-2 border-gray-900 rounded-full cursor-grab ring-4 ring-white">
      {children}
    </h4>
  );
};

FlowBuilder.RemoveBtn = function FlowBuilderRemoveBtn({
  onClick,
}: {
  onClick: () => void;
}) {
  return (
    <button
      className="absolute z-20 -top-0 right-5 size-3 flex items-center justify-center rounded-full bg-red-500 text-white text-xs hover:bg-red-600"
      title="Remove this step"
      onClick={onClick}
    >
      -
    </button>
  );
};

FlowBuilder.AddBtn = function FlowBuilderAddBtn({
  onClick,
}: {
  onClick: () => void;
}) {
  return (
    <button
      className="mt-1 size-6 text-lg text-gray-400 bg-white z-10 flex items-center justify-center p-1 border-2 border-gray-400 rounded-full ring-2 ring-white"
      type="button"
      onClick={onClick}
    >
      +
    </button>
  );
};
